import React, { useState } from 'react';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { IoQrCode } from "react-icons/io5";
import './AccountCard.scss';

function AccountCard() {
  const [isDetailsVisible, setIsDetailsVisible] = useState(false);

  return (
    <div className='account-card'>
      <div className='account-info'>
        <span>financial platform (DDB)</span>
        {isDetailsVisible ? (
          <>
            <div className='account-numbers'>
              <div className='amount'>1168.00</div>
              <hr />
              <div className='number'>532491002966DDB389B0DC68BA3FD1 <IoQrCode /></div>
            </div>
          </>
        ) : (
          <>
            <div className='masked-info'>
              <div className='stars'>*****</div>
              <hr />
              <p>************* <IoQrCode /></p>
            </div>
          </>
        )}
      </div>
      <button className='toggle-button' onClick={() => setIsDetailsVisible(!isDetailsVisible)}>
        {isDetailsVisible ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
      </button>
    </div>
  );
}

export default AccountCard;
